module.exports = __webpack_public_path__ + "06_hair_gold.e252c4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/06_hair_gold.png
// module id = D890
// module chunks = 0